import { jsx } from "react/jsx-runtime";
import { Root as Root2, Item as Item2, Indicator } from "../node_modules/.pnpm/@radix-ui_react-radio-group@1.3.8_@types_react-dom@18.3.7_@types_react@18.3.25__@types__02896d03a47eea0f1be2cd3ebbb59e9d/node_modules/@radix-ui/react-radio-group/dist/index.js";
import * as React from "react";
import { cn } from "../lib/utils.js";
import Circle from "../node_modules/.pnpm/lucide-react@0.469.0_react@19.1.1/node_modules/lucide-react/dist/esm/icons/circle.js";
const RadioGroup = React.forwardRef(({ className, ...props }, ref) => {
  return /* @__PURE__ */ jsx(
    Root2,
    {
      className: cn("grid gap-2", className),
      ...props,
      ref
    }
  );
});
RadioGroup.displayName = Root2.displayName;
const RadioGroupItem = React.forwardRef(({ className, ...props }, ref) => {
  return /* @__PURE__ */ jsx(
    Item2,
    {
      ref,
      className: cn(
        "aspect-square h-4 w-4 rounded-full border border-primary text-primary ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className
      ),
      ...props,
      children: /* @__PURE__ */ jsx(Indicator, { className: "flex items-center justify-center", children: /* @__PURE__ */ jsx(Circle, { className: "h-2.5 w-2.5 fill-current text-current" }) })
    }
  );
});
RadioGroupItem.displayName = Item2.displayName;
export {
  RadioGroup,
  RadioGroupItem
};
//# sourceMappingURL=radio-group.js.map
